export default "__VITE_ASSET__CVufSiGW__"